// extracted by mini-css-extract-plugin
module.exports = {"memorableSection":"style-module--memorableSection--37xaT","backgroundImage":"style-module--backgroundImage--2dlUM","text":"style-module--text--2YkdU"};